import { render, staticRenderFns } from "./tools.vue?vue&type=template&id=88574a38&scoped=true&"
import script from "./tools.vue?vue&type=script&lang=js&"
export * from "./tools.vue?vue&type=script&lang=js&"
import style0 from "./tools.vue?vue&type=style&index=0&id=88574a38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88574a38",
  null
  
)

export default component.exports